import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { RestApi } from '../shared/apiUrls';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { PromiseResult } from '../models/PromiseResult';


@Injectable({
  providedIn: 'root'
})
export class CertificatesService {

  constructor(private readonly http: HttpClient) { }

  private handleError(error: HttpErrorResponse) {
    return throwError(error);
  }

  GetOwnedCertificates(): Observable<PromiseResult> {
    return this.http.get<PromiseResult>(RestApi.Urls.DoctorCertificatesApi + "get/owned").pipe(
      catchError(this.handleError)
    );
  };

  GetPendingCertificates(): Observable<PromiseResult> {
    return this.http.get<PromiseResult>(RestApi.Urls.DoctorCertificatesApi + "get/pending").pipe(
      catchError(this.handleError)
    );
  };

  GetCertificates(certificate_id: string): Observable<PromiseResult> {
    return this.http.get<PromiseResult>(RestApi.Urls.DoctorCertificatesApi + "download/" + certificate_id).pipe(
      catchError(this.handleError)
    );
  };

  UploadCertificate(data: FormData , user_guid: string): Observable<PromiseResult> {
    return this.http.post<PromiseResult>(RestApi.Urls.DoctorCertificatesApi + "upload/" + user_guid, data)
      .pipe(
        catchError(this.handleError)
      );
  }

}
